<template>
  <resource
    resource="coupon"
    resourceName="Gutschein"
    :attributes="[
      {
        name: 'slug',
        label: 'Code',
        type: 'CodeSelector'
      },
      {
        name: 'start',
        label: 'Start',
        type: 'DateTimeSelector',
        value: moment().format('YYYY-MM-DD HH:mm:ss')
      },
      {
        name: 'end',
        label: 'Ende',
        type: 'DateTimeSelector',
        value: moment()
          .add(1, 'weeks')
          .format('YYYY-MM-DD HH:mm:ss')
      },
      {
        name: 'amount',
        label: 'Menge an Coins'
      },
      {
        name: 'for_one',
        label: 'Einmal einlösbar?',
        type: 'CheckboxSelector',
        value: false
      },
      {
        name: 'active',
        label: 'Aktiv?',
        type: 'CheckboxSelector',
        value: false
      }
    ]"
  >
    <div slot="title">
      <h4>Gutschein erstellen</h4>
    </div>
  </resource>
</template>

<script lang="babel">
import moment from 'moment';
export default {
  data() {
    return {
      moment: moment
    };
  }
}
</script>
